<template>
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">WhatsApp</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">

            <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h4 class="mb-0 fw-bold">WhatsApp Hub</h4>
                    <span class="text-muted fs-7">Gerencie a sessão e os disparos de mensagens</span>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <button v-if="status === 'CONNECTED'" class="btn btn-pmg-danger" @click="confirmDisconnect"
                        :disabled="loading">
                        <i class="bi bi-box-arrow-right me-1"></i> Desconectar Sessão
                    </button>
                    <button v-else class="btn btn-pmg-primary" @click="connectWhatsApp" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        <i v-else class="bi bi-qr-code-scan me-1"></i> Gerar QR Code
                    </button>
                </div>
            </div>

            <ul class="nav nav-pills mb-4 pb-3 border-bottom" id="whatsapp-tabs">
                <li class="nav-item">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'connection' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'connection'">
                        <i class="bi bi-gear-fill me-2"></i> Conexão e Testes
                    </a>
                </li>
                <li class="nav-item ms-2">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'mass_dispatch' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'mass_dispatch'">
                        <i class="bi bi-rocket-takeoff-fill me-2"></i> Disparo em Massa
                    </a>
                </li>
                <li class="nav-item ms-2">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'history' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'history'">
                        <i class="bi bi-clock-history me-2"></i> Histórico
                    </a>
                </li>
                <li class="nav-item ms-2">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'chat' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'chat'">
                        <i class="bi bi-chat-dots me-2"></i> Chat
                    </a>
                </li>
                <li class="nav-item ms-2">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'bot_training' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'bot_training'">
                        <i class="bi bi-robot me-2"></i> Treinamento IA
                    </a>
                </li>
                <li class="nav-item ms-2">
                    <a class="nav-link cursor-pointer fw-semibold px-4 rounded-pill transition-all"
                        :class="activeTab === 'metrics' ? 'bg-pmg-primary text-white shadow-sm' : 'text-muted hover-bg-light'"
                        @click="activeTab = 'metrics'">
                        <i class="bi bi-graph-up me-2"></i> Métricas
                    </a>
                </li>
            </ul>

            <div v-show="activeTab === 'connection'">
                <div class="row g-4">
                    <div class="col-md-6 border-end pe-4">
                        <h5 class="fw-bold mb-4">Status da Instância</h5>

                        <div v-if="status === 'LOADING'" class="text-center py-5">
                            <div class="spinner-border text-primary mb-3" role="status"></div>
                            <p class="text-muted fw-medium">Verificando status do microserviço...</p>
                        </div>

                        <div v-else-if="status === 'DISCONNECTED'" class="text-center py-5 bg-light rounded-4 border">
                            <i class="bi bi-phone-vibrate fs-1 text-secondary opacity-50 mb-3 d-block"></i>
                            <h5 class="fw-bold text-dark">Nenhum aparelho conectado</h5>
                            <p class="text-muted small px-4">
                                Clique em "Gerar QR Code" no canto superior para iniciar uma nova sessão e conectar o
                                WhatsApp de disparo.
                            </p>
                        </div>

                        <div v-else-if="status === 'WAITING_QR'" class="text-center py-4 bg-light rounded-4 border">
                            <h6 class="fw-bold text-dark mb-3">Escaneie o QR Code</h6>
                            <div class="bg-white p-3 d-inline-block rounded-3 shadow-sm mb-3">
                                <img v-if="qrCode" :src="qrCode" alt="QR Code WhatsApp"
                                    style="max-width: 250px; height: auto;" />
                                <div v-else class="spinner-border text-primary my-5" role="status"></div>
                            </div>
                            <p class="text-muted small mb-0 px-4">
                                Abra o WhatsApp no seu celular, vá em <strong>Aparelhos Conectados</strong> e aponte a
                                câmera.
                            </p>
                            <div class="mt-3">
                                <span
                                    class="badge bg-warning-subtle text-warning border border-warning px-3 py-2 rounded-pill">
                                    <span class="spinner-grow spinner-grow-sm me-1" role="status"></span> Aguardando
                                    leitura...
                                </span>
                            </div>
                        </div>

                        <div v-else-if="status === 'CONNECTED'"
                            class="text-center py-5 bg-success-subtle rounded-4 border border-success">
                            <i class="bi bi-whatsapp fs-1 text-success mb-3 d-block"></i>
                            <h5 class="fw-bold text-success">WhatsApp Conectado!</h5>
                            <p class="text-success opacity-75 small px-4 mb-0">
                                A API está pronta para receber e disparar as mensagens na fila.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-6 ps-4">
                        <h5 class="fw-bold mb-4">Teste de Disparo</h5>
                        <p class="text-muted small mb-4">
                            Utilize este painel para testar se as mensagens estão chegando corretamente ao número de
                            destino.
                        </p>

                        <div class="card card-body bg-light border-0 rounded-4">
                            <div class="mb-3">
                                <label class="form-label small fw-bold text-muted">Número de Destino (com DDD)</label>
                                <input v-model="testMessage.number" @input="applyPhoneMask" type="text"
                                    class="form-control form-control-pmg" placeholder="Ex: (11) 99999-9999"
                                    :disabled="status !== 'CONNECTED'" maxlength="15">
                            </div>
                            <div class="mb-3">
                                <label class="form-label small fw-bold text-muted">Mensagem</label>
                                <textarea v-model="testMessage.message" class="form-control form-control-pmg" rows="3"
                                    placeholder="Olá, esta é uma mensagem de teste do Dailypag."
                                    :disabled="status !== 'CONNECTED'"></textarea>
                            </div>
                            <div class="text-end mt-2">
                                <button class="btn btn-pmg-primary w-100" @click="sendTestMessage"
                                    :disabled="status !== 'CONNECTED' || !testMessage.number || !testMessage.message || isSendingTest">
                                    <span v-if="isSendingTest" class="spinner-border spinner-border-sm me-2"
                                        role="status"></span>
                                    <i v-else class="bi bi-send-fill me-2"></i> Enviar Mensagem
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="activeTab === 'mass_dispatch'">
                <div class="row g-4">
                    <div class="col-md-7 border-end pe-4">
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <h5 class="fw-bold mb-0">Nova Campanha</h5>
                            <span v-if="status !== 'CONNECTED'" class="badge bg-danger-subtle text-danger">⚠️ WhatsApp
                                Desconectado</span>
                        </div>

                        <div class="card card-body bg-light border-0 rounded-4 mb-4">
                            <div class="mb-3">
                                <div class="d-flex justify-content-between align-items-end mb-2">
                                    <label class="form-label small fw-bold text-muted mb-0">1. Importar Lista
                                        (.xlsx)</label>
                                    <button type="button" @click="downloadExample"
                                        class="btn btn-link text-pmg-primary text-decoration-none p-0 d-flex align-items-center"
                                        style="font-size: 0.8rem; font-weight: 600;">
                                        <i class="bi bi-file-earmark-arrow-down-fill me-1"></i> Baixar Planilha Exemplo
                                    </button>
                                </div>
                                <input type="file" accept=".xlsx, .xls" @change="handleFileUpload" ref="fileInput"
                                    class="form-control form-control-pmg bg-white" />
                                <div class="form-text mt-2" style="font-size: 0.8rem;">
                                    A planilha deve conter obrigatoriamente uma coluna chamada
                                    <strong>Telefone</strong>.
                                </div>
                                <div v-if="duplicateErrors.length > 0"
                                    class="alert alert-danger mt-3 mb-0 rounded-4 border-0 p-3"
                                    style="background-color: #fef2f2; color: #991b1b; font-size: 0.85rem;">
                                    <h6 class="fw-bold mb-2">
                                        <i class="bi bi-exclamation-triangle-fill me-1"></i> Ops! Encontramos {{
                                            duplicateErrors.length }} números repetidos:
                                    </h6>

                                    <div class="overflow-auto pe-2 mb-2 custom-scrollbar-danger"
                                        style="max-height: 120px;">
                                        <ul class="mb-0 ps-3">
                                            <li v-for="(err, i) in duplicateErrors" :key="i" class="mb-1">{{ err }}</li>
                                        </ul>
                                    </div>

                                    <span class="fw-medium d-block pt-2 border-top"
                                        style="border-color: rgba(220, 38, 38, 0.2) !important;">
                                        Por favor, remova as duplicações no Excel e importe novamente.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="card card-body bg-light border-0 rounded-4">
                            <div class="mb-3">
                                <label class="form-label small fw-bold text-muted">2. Mensagem Padrão</label>
                                <textarea v-model="massMessageTemplate" class="form-control form-control-pmg" rows="5"
                                    placeholder="Digite a mensagem que será enviada para todos os contatos da lista..."></textarea>
                            </div>
                            <div class="row mb-3 mt-3 pt-3 border-top">
                                <div class="col-12 mb-2">
                                    <label class="form-label small fw-bold text-muted">3. Agendamento (Opcional)</label>
                                </div>
                                <div class="col-6">
                                    <input type="date" v-model="scheduleDate" class="form-control form-control-pmg"
                                        :min="todayDate">
                                </div>
                                <div class="col-6">
                                    <input type="time" v-model="scheduleTime" class="form-control form-control-pmg">
                                </div>
                                <div v-if="scheduleError" class="col-12 mt-1 text-danger small fw-medium">
                                    <i class="bi bi-x-circle me-1"></i> {{ scheduleError }}
                                </div>
                            </div>
                            <button class="btn btn-pmg-primary w-100 py-3 mt-2" @click="sendMassMessages"
                                :disabled="!isValidToSubmit || isSendingMass || status !== 'CONNECTED'">
                                <span v-if="isSendingMass" class="spinner-border spinner-border-sm me-2"
                                    role="status"></span>
                                <i v-else class="bi bi-rocket-takeoff-fill me-2"></i>
                                {{ isSendingMass ? 'Processando Lote...' : `Disparar para ${contacts.length} contatos`
                                }}
                            </button>
                        </div>
                    </div>

                    <div class="col-md-5 ps-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-bold text-dark mb-0">Preview da Lista</h6>
                            <div class="d-flex align-items-center gap-2">
                                <button v-if="contacts.length > 0" @click="clearList"
                                    class="btn btn-sm btn-outline-danger border-0 d-flex align-items-center py-1 px-2 transition-all"
                                    title="Descartar planilha atual">
                                    <i class="bi bi-trash3-fill me-1"></i> Limpar
                                </button>
                                <span class="badge bg-pmg-primary rounded-pill">{{ contacts.length }} Contatos</span>
                            </div>
                        </div>

                        <div class="card border border-light shadow-sm rounded-4 h-100" style="max-height: 450px;">
                            <div v-if="contacts.length === 0"
                                class="card-body d-flex flex-column justify-content-center align-items-center text-center py-5 h-100">
                                <i class="bi bi-file-earmark-excel fs-1 text-muted opacity-25 mb-3"></i>
                                <p class="text-muted small mb-0">Importe uma planilha para<br>visualizar os contatos
                                    aqui.</p>
                            </div>

                            <div v-else class="card-body p-0 overflow-auto">
                                <ul class="list-group list-group-flush rounded-4">
                                    <li v-for="(contact, index) in contacts" :key="index"
                                        class="list-group-item d-flex justify-content-between align-items-center py-3 border-light">
                                        <div>
                                            <span class="fw-medium text-dark d-block" style="font-size: 0.9rem;">{{
                                                contact.Telefone }}</span>
                                            <span v-if="contact.Nome" class="text-muted small">{{ contact.Nome }}</span>
                                        </div>
                                        <span
                                            class="badge bg-success-subtle text-success rounded-pill px-3 py-2 border border-success">Pronto</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="activeTab === 'history'">
                <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                    <div>
                        <h4 class="mb-0 fw-bold">Campanhas Recentes</h4>
                        <span class="text-muted fs-7">Exibindo histórico de disparos</span>
                    </div>
                    <button class="btn btn-pmg-light" @click="fetchHistory">
                        <i class="bi bi-arrow-clockwise me-1"></i> Atualizar
                    </button>
                </div>

                <div class="table-responsive">
                    <table class="table table-pmg align-middle">
                        <thead>
                            <tr>
                                <th style="width: 20%">Data/Hora Alvo</th>
                                <th style="width: 45%">Mensagem Padrão</th>
                                <th style="width: 15%" class="text-center">Destinatários</th>
                                <th style="width: 10%" class="text-center">Status</th>
                                <th style="width: 10%" class="text-end">Ações</th>
                            </tr>
                        </thead>

                        <tbody v-if="campaignHistory.length > 0">
                            <tr v-for="campanha in campaignHistory" :key="campanha.id">
                                <td class="fw-bold text-dark">
                                    {{ formatDateTime(campanha.scheduled_at) }}
                                </td>
                                <td>
                                    <div class="pmg-desc-cell text-truncate" style="max-width: 400px;"
                                        :title="campanha.message_template">
                                        {{ campanha.message_template }}
                                    </div>
                                </td>
                                <td class="text-center">
                                    <button @click="openRecipientsModal(campanha)"
                                        class="btn btn-sm btn-light border rounded-3 px-3 py-1 fw-bold text-dark shadow-sm"
                                        title="Ver lista de contatos">
                                        <i class="bi bi-people-fill me-1 text-pmg-primary"></i> {{
                                            campanha.total_contacts }}
                                    </button>
                                </td>
                                <td class="text-center">
                                    <span v-if="campanha.status === 'pendente'"
                                        class="badge bg-warning-subtle text-warning border border-warning rounded-pill px-3 py-2">Pendente</span>
                                    <span v-else-if="campanha.status === 'concluida'"
                                        class="badge bg-success-subtle text-success border border-success rounded-pill px-3 py-2">Concluída</span>
                                    <span v-else-if="campanha.status === 'cancelada'"
                                        class="badge bg-danger-subtle text-danger border border-danger rounded-pill px-3 py-2">Cancelada</span>
                                    <span v-else class="badge bg-light text-secondary border rounded-pill px-3 py-2">{{
                                        campanha.status }}</span>
                                </td>
                                <td class="text-end">
                                    <button v-if="campanha.status === 'pendente'"
                                        @click="confirmCancelCampaign(campanha)" class="btn btn-sm btn-pmg-danger px-3"
                                        title="Cancelar disparo">
                                        <i class="bi bi-x-circle me-1"></i> Cancelar
                                    </button>
                                </td>
                            </tr>
                        </tbody>

                        <tbody v-else>
                            <tr>
                                <td colspan="5" class="text-center py-5 text-muted">
                                    <div class="d-flex flex-column align-items-center justify-content-center">
                                        <i class="bi bi-inbox fs-1 mb-2 text-secondary opacity-50"></i>
                                        <span class="fw-medium">Não há campanhas registradas no momento.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-show="activeTab === 'chat'" class="h-100">
                <div class="row g-0 rounded-4 overflow-hidden shadow-sm bg-white" style="height: 75vh;">

                    <div class="col-md-4 border-end d-flex flex-column bg-white h-100">
                        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
                            <h6 class="fw-bold mb-0 text-primary">Conversas</h6>
                            <button class="btn btn-sm btn-outline-primary" @click="fetchConversations">
                                <i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>

                        <div class="overflow-auto h-100 p-2">
                            <div v-for="conv in conversations" :key="conv.phone" @click="openChat(conv.phone)"
                                class="p-3 mb-1 rounded-3 cursor-pointer conv-item d-flex align-items-center"
                                :class="{ 'active': activeChatPhone === conv.phone }">

                                <div class="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                                    style="width: 45px; height: 45px;">
                                    <i class="bi bi-person text-primary fs-4"></i>
                                </div>

                                <div class="flex-grow-1 overflow-hidden">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <h6 class="mb-0 fw-semibold text-dark text-truncate" style="font-size: 0.9rem;">
                                            {{ conv.name !== 'Desconhecido' ? conv.name : formatPhone(conv.phone) }}
                                        </h6>
                                        <small class="text-muted flex-shrink-0 ms-2" style="font-size: 0.7rem;">
                                            {{ formatTimeOnly(conv.last_activity) }}
                                        </small>
                                    </div>
                                    <div class="text-muted small text-truncate" style="font-size: 0.8rem;">
                                        <span v-if="conv.messages && conv.messages.length > 0">
                                            <i v-if="conv.messages[0].enviada_por_mim"
                                                class="bi bi-check2-all me-1"></i>
                                            {{ conv.messages[0].body }}
                                        </span>
                                        <span v-else>{{ formatPhone(conv.phone) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-8 d-flex flex-column h-100">
                        <!-- Cabeçalho do Chat Ativo -->
                        <div class="p-3 border-bottom bg-white d-flex align-items-center justify-content-between"
                            v-if="activeChatPhone">
                            <div class="d-flex align-items-center">
                                <div class="avatar-circle me-3 rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center"
                                    style="width: 40px; height: 40px;">
                                    <i class="bi bi-person-fill text-primary"></i>
                                </div>
                                <div>
                                    <h6 class="mb-0 fw-bold text-dark">{{ activeChatName || formatPhone(activeChatPhone)
                                        }}</h6>
                                    <small v-if="activeChatName" class="text-muted d-block" style="font-size: 0.75rem;">
                                        {{ formatPhone(activeChatPhone) }}
                                    </small>
                                </div>
                            </div>

                            <!-- Novo Toggle de Status da IA -->
                            <div v-if="activeConversation"
                                class="d-flex align-items-center bg-light px-3 py-2 rounded-pill border">
                                <div class="form-check form-switch mb-0" style="min-height: auto;">
                                    <input class="form-check-input cursor-pointer" type="checkbox" role="switch"
                                        :id="'aiToggle-' + activeChatPhone" :checked="activeConversation.bot_enabled"
                                        @change="toggleAiStatus" :disabled="isTogglingAi">
                                    <label class="form-check-label ms-2 small fw-bold cursor-pointer"
                                        :for="'aiToggle-' + activeChatPhone"
                                        :class="activeConversation.bot_enabled ? 'text-primary' : 'text-danger'">
                                        <i class="bi bi-robot me-1"></i>
                                        {{ activeConversation.bot_enabled ? 'IA Ativa' : 'IA Pausada' }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="flex-grow-1 overflow-auto chat-messages" ref="chatScrollArea">
                            <div v-for="msg in activeChatMessages" :key="msg.id" class="mb-3 d-flex"
                                :class="msg.status === 'received' ? 'justify-content-start' : 'justify-content-end'">

                                <div class="bubble" :class="msg.status === 'received' ? 'received' : 'sent'">
                                    <div>{{ msg.body }}</div>
                                    <div class="text-end mt-1" style="font-size: 0.7rem; opacity: 0.6;">
                                        {{ formatTimeOnly(msg.created_at) }}
                                        <i v-if="msg.status === 'sent'" class="bi bi-check2 ms-1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-3 bg-white border-top d-flex align-items-center gap-2">
                            <input type="text" class="form-control rounded-pill px-4 border-light shadow-sm"
                                placeholder="Escreva uma mensagem..." v-model="newChatMessage"
                                @keyup.enter="sendChatMessage">
                            <button class="btn btn-primary rounded-circle shadow-sm" style="width: 45px; height: 45px;"
                                @click="sendChatMessage" :disabled="!newChatMessage.trim()">
                                <i class="bi bi-send-fill"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeTab === 'bot_training'">
                <div class="row g-4 align-items-stretch">

                    <!-- Coluna Esquerda: Perguntas Pendentes (Só aparece se houver > 0) -->
                    <div v-if="pendingQuestions.length > 0"
                        class="col-md-6 border-end pe-4 d-flex flex-column transition-all">
                        <div class="d-flex justify-content-between align-items-center mb-4 flex-shrink-0">
                            <div>
                                <h5 class="fw-bold mb-0">Dúvidas Pendentes</h5>
                                <span class="text-muted fs-7">O que a IA não soube responder</span>
                            </div>
                            <button class="btn btn-sm btn-pmg-light" @click="fetchPendingQuestions">
                                <i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>

                        <!-- Lista de dúvidas pendentes (Removemos o Empty State pois a coluna inteira some) -->
                        <div class="overflow-auto custom-scrollbar-danger flex-grow-1"
                            style="max-height: 550px; padding-right: 10px;">
                            <div v-for="question in pendingQuestions" :key="question.id"
                                class="card border border-warning shadow-sm rounded-4 mb-3">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <span
                                            class="badge bg-warning-subtle text-warning border border-warning px-2 py-1 rounded-pill">
                                            <i class="bi bi-exclamation-circle me-1"></i> Pendente
                                        </span>
                                        <small class="text-muted fw-medium">{{ formatPhone(question.contact?.phone)
                                            }}</small>
                                    </div>
                                    <p class="fw-bold text-dark mb-3">"{{ question.question }}"</p>

                                    <div class="d-flex gap-2">
                                        <button class="btn btn-pmg-primary flex-grow-1 py-2"
                                            @click="openResolveModal(question)">
                                            <i class="bi bi-journal-plus me-1"></i> Ensinar Resposta
                                        </button>
                                        <button class="btn btn-pmg-danger px-3 py-2"
                                            @click="confirmDeleteQuestion(question)" title="Descartar Dúvida">
                                            <i class="bi bi-trash3-fill"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Coluna Direita: Base de Conhecimento (Expande para col-12 dinamicamente) -->
                    <div :class="pendingQuestions.length > 0 ? 'col-md-6 ps-4' : 'col-12'"
                        class="d-flex flex-column transition-all">

                        <!-- Cabeçalho com os botões de Grupos e Regras -->
                        <div class="d-flex justify-content-between align-items-center mb-4 flex-shrink-0">
                            <div>
                                <h5 class="fw-bold mb-0">Base de Conhecimento</h5>
                            </div>
                            <div class="d-flex gap-2">
                                <button class="btn btn-sm btn-pmg-light shadow-sm" @click="openManageGroupsModal">
                                    <i class="bi bi-tags-fill me-1"></i> Gerenciar Grupos
                                </button>
                                <button class="btn btn-sm btn-pmg-primary shadow-sm" @click="openCreateRuleModal">
                                    <i class="bi bi-plus-circle me-1"></i> Nova Regra
                                </button>
                            </div>
                        </div>

                        <!-- Lista de Regras Ativas -->
                        <div class="d-flex justify-content-between align-items-center mb-2 flex-shrink-0">
                            <h6 class="fw-bold text-dark mb-0">Regras Ativas ({{ filteredKnowledgeBase.length }})</h6>
                            <button class="btn btn-sm btn-outline-secondary border-0" @click="fetchKnowledgeBase">
                                <i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>

                        <!-- Filtros de Regras -->
                        <div class="d-flex gap-2 mb-3 flex-shrink-0">

                            <!-- Campo de Busca por Texto -->
                            <div class="position-relative flex-grow-1">
                                <i class="bi bi-search position-absolute text-muted"
                                    style="top: 50%; transform: translateY(-50%); left: 16px;"></i>
                                <input type="text" v-model="searchRuleQuery" class="form-control form-control-pmg"
                                    style="padding-left: 45px;" placeholder="Buscar por título ou instrução...">
                            </div>

                            <!-- Dropdown de Filtro por Grupo -->
                            <select v-model="selectedGroupFilter" class="form-select form-control-pmg shadow-none"
                                style="max-width: 220px; cursor: pointer; color: #64748b;">
                                <option value="">Todos os Grupos</option>
                                <option value="global">Global (Sem grupo)</option>
                                <option v-for="group in groups" :key="group.id" :value="group.id">
                                    {{ group.name }}
                                </option>
                            </select>

                        </div>

                        <div class="card border border-light shadow-sm rounded-4 flex-grow-1 d-flex flex-column"
                            style="max-height: 550px;">
                            <div class="card-body p-0 overflow-auto custom-scrollbar-danger h-100">

                                <div v-if="knowledgeBase.length === 0"
                                    class="d-flex flex-column justify-content-center align-items-center h-100 py-5 text-muted">
                                    <i class="bi bi-inbox fs-1 mb-2 opacity-25"></i>
                                    <span class="small fw-medium">Nenhuma regra cadastrada.</span>
                                </div>

                                <ul v-else class="list-group list-group-flush rounded-4">
                                    <li v-for="rule in filteredKnowledgeBase" :key="rule.id"
                                        class="list-group-item p-3 border-light">
                                        <div class="d-flex justify-content-between align-items-start mb-2">
                                            <div class="d-flex flex-column mb-2">
                                                <span class="fw-bold text-primary" style="font-size: 0.95rem;">{{
                                                    rule.title }}</span>
                                                <div class="mt-1 d-flex gap-1 flex-wrap">
                                                    <span v-if="!rule.groups || rule.groups.length === 0"
                                                        class="badge bg-secondary-subtle text-secondary border border-secondary rounded-pill px-2 py-1"
                                                        style="font-size: 0.65rem;">
                                                        Global / Todos
                                                    </span>
                                                    <span v-for="group in rule.groups" :key="group.id"
                                                        class="badge bg-info-subtle text-info border border-info rounded-pill px-2 py-1"
                                                        style="font-size: 0.65rem;">
                                                        {{ group.name }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="d-flex gap-1 flex-shrink-0 ms-2">
                                                <button
                                                    class="btn btn-sm btn-light border-0 text-secondary hover-bg-light p-1 px-2 rounded-2"
                                                    @click="openEditRuleModal(rule)" title="Editar Regra">
                                                    <i class="bi bi-pencil-fill fs-7"></i>
                                                </button>
                                                <button
                                                    class="btn btn-sm btn-light border-0 text-danger hover-bg-light p-1 px-2 rounded-2"
                                                    @click="confirmDeleteRule(rule)" title="Excluir Regra">
                                                    <i class="bi bi-trash3-fill fs-7"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <p class="text-muted small mb-0 lh-sm text-break"
                                            style="white-space: pre-line;">
                                            {{ rule.content }}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-show="activeTab === 'metrics'">
                <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                    <div>
                        <h4 class="mb-0 fw-bold">Dashboard de Métricas</h4>
                        <span class="text-muted fs-7">Visão geral dos últimos 15 dias</span>
                    </div>
                    <button class="btn btn-pmg-light" @click="fetchMetrics">
                        <i class="bi bi-arrow-clockwise me-1"></i> Atualizar
                    </button>
                </div>

                <div class="row g-3 mb-4" v-if="metrics">
                    <div class="col-md-4 col-sm-6">
                        <div class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-primary bg-opacity-10 text-primary">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase">Mensagens Enviadas</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.total_sent }}</h3>
                                </div>
                                <i class="bi bi-send-check fs-1 opacity-50"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-success bg-opacity-10 text-success">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase">Mensagens Recebidas</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.total_received }}</h3>
                                </div>
                                <i class="bi bi-chat-left-text fs-1 opacity-50"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-danger bg-opacity-10 text-danger">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase">Falhas de Envio</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.total_failed }}</h3>
                                </div>
                                <i class="bi bi-exclamation-octagon fs-1 opacity-50"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-light text-dark">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase text-muted">Contatos Únicos</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.unique_numbers }}</h3>
                                </div>
                                <i class="bi bi-people fs-1 text-secondary opacity-50"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div
                            class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-warning bg-opacity-10 text-warning text-dark">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase">Campanhas Ativas</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.active_campaigns }}</h3>
                                </div>
                                <i class="bi bi-megaphone fs-1 opacity-50"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="card border-0 shadow-sm rounded-4 h-100 p-3 bg-light text-dark">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p class="mb-1 fw-bold small text-uppercase text-muted">Campanhas Concluídas</p>
                                    <h3 class="mb-0 fw-bold">{{ metrics.kpis.finished_campaigns }}</h3>
                                </div>
                                <i class="bi bi-check2-all fs-1 text-secondary opacity-50"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card border-0 shadow-sm rounded-4 p-4">
                    <h6 class="fw-bold mb-4 text-muted">Volume de Mensagens: Enviadas x Recebidas</h6>
                    <div style="height: 300px; width: 100%;">
                        <canvas ref="metricsChartCanvas"></canvas>
                    </div>
                </div>
            </div>

        </div>
        <div class="modal fade" id="confirmDisconnectModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-box-arrow-right fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Encerrar Sessão?</h5>
                        <p class="text-muted small">O disparo automático de cobranças será interrompido até que você
                            conecte novamente.</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDisconnect">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmCancelCampaignModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-warning mb-3">
                            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Cancelar Campanha?</h5>
                        <p class="text-muted small">
                            A campanha será marcada como cancelada e não será enviada. Esta ação não pode ser desfeita.
                        </p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Voltar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeCancel">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="campaignRecipientsModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <div>
                            <h5 class="fw-bold m-0">Destinatários da Campanha</h5>
                            <span class="text-muted small">Lista de envio e status de entrega</span>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body px-4">
                        <div v-if="loadingRecipients" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status"></div>
                            <p class="mt-2 text-muted small">Carregando contatos...</p>
                        </div>

                        <div v-else class="table-responsive">
                            <table class="table table-sm table-borderless align-middle">
                                <thead class="border-bottom">
                                    <tr>
                                        <th class="text-muted small text-uppercase pb-2">Telefone</th>
                                        <th class="text-muted small text-uppercase pb-2 text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="msg in selectedCampaignMessages" :key="msg.id" class="border-bottom">
                                        <td class="py-2 fw-medium text-dark">{{ formatPhone(msg.phone) }}</td>
                                        <td class="py-2 text-center">
                                            <span v-if="msg.status === 'pendente'"
                                                class="badge bg-warning-subtle text-warning border border-warning rounded-pill px-2">Pendente</span>
                                            <span v-else-if="msg.status === 'sent' || msg.status === 'enviado'"
                                                class="badge bg-success-subtle text-success border border-success rounded-pill px-2">Enviado</span>
                                            <span v-else-if="msg.status === 'falha' || msg.status === 'failed'"
                                                class="badge bg-danger-subtle text-danger border border-danger rounded-pill px-2"
                                                :title="msg.error_reason">
                                                <i class="bi bi-info-circle me-1"></i> Falha
                                            </span>
                                            <span v-else
                                                class="badge bg-light text-secondary border rounded-pill px-2">{{
                                                    msg.status }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light w-100" data-bs-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="resolveQuestionModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 p-2">
                <div class="modal-header border-0">
                    <h5 class="fw-bold m-0"><i class="bi bi-robot text-primary me-2"></i>Ensinar o Bot</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="alert bg-warning-subtle text-warning border-0 rounded-3 mb-4 p-3">
                        <small class="fw-bold text-uppercase mb-1 d-block">O cliente perguntou:</small>
                        <span class="fst-italic">"{{ resolveForm.question }}"</span>
                    </div>

                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Tópico / Título da Regra</label>
                        <input type="text" v-model="resolveForm.title" class="form-control form-control-pmg"
                            placeholder="Ex: Formas de Pagamento">
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">A Resposta (Base de Conhecimento)</label>
                        <textarea v-model="resolveForm.content" class="form-control form-control-pmg" rows="4"
                            placeholder="Escreva a instrução clara para a IA usar no futuro..."></textarea>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button class="btn btn-pmg-light" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-pmg-primary" @click="submitResolve"
                        :disabled="isResolving || !resolveForm.title || !resolveForm.content">
                        <span v-if="isResolving" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Salvar e Ensinar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmDeleteQuestionModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-danger mb-3">
                        <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                    </div>
                    <h5 class="fw-bold">Tem certeza?</h5>
                    <p class="text-muted small">
                        Descartar a dúvida "{{ questionToDelete?.question }}" sem ensinar a IA?
                    </p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-danger px-4 rounded-3" @click="executeQuestionDeletion"
                        :disabled="isDeletingQuestion">
                        <span v-if="isDeletingQuestion" class="spinner-border spinner-border-sm me-1"
                            role="status"></span>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal de Edição de Regra -->
    <div class="modal fade" id="editRuleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 p-2">
                <div class="modal-header border-0">
                    <h5 class="fw-bold m-0"><i class="bi bi-pencil-square text-primary me-2"></i>Editar Regra</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Título da Regra</label>
                        <input type="text" v-model="ruleToEdit.title" class="form-control form-control-pmg">
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Vincular aos Grupos (Opcional)</label>

                        <div v-if="ruleToEdit.group_ids && ruleToEdit.group_ids.length > 0"
                            class="d-flex flex-wrap gap-2 mb-2 p-2 border rounded-3 bg-light border-light">
                            <span v-for="id in ruleToEdit.group_ids" :key="id"
                                class="badge bg-pmg-primary d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                                {{ getGroupName(id) }}
                                <button type="button" class="btn-close btn-close-white" style="font-size: 0.5rem;"
                                    @click="removeGroupFromRule(id, 'ruleToEdit')"></button>
                            </span>
                        </div>

                        <select class="form-select form-control-pmg shadow-none"
                            @change="addGroupToRule($event, 'ruleToEdit')">
                            <option value="" selected>Selecione um grupo para vincular...</option>
                            <option v-for="group in unselectedGroups(ruleToEdit.group_ids)" :key="group.id"
                                :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                        <div class="form-text" style="font-size: 0.75rem;">Se vazio, a regra será Global.</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Instrução para a IA</label>
                        <textarea v-model="ruleToEdit.content" class="form-control form-control-pmg"
                            rows="5"></textarea>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button class="btn btn-pmg-light" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-pmg-primary" @click="submitEditRule"
                        :disabled="isUpdatingRule || !ruleToEdit.title || !ruleToEdit.content">
                        <span v-if="isUpdatingRule" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        Salvar Alterações
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal de Confirmação de Exclusão de Regra -->
    <div class="modal fade" id="confirmDeleteRuleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-danger mb-3">
                        <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                    </div>
                    <h5 class="fw-bold">Excluir Regra?</h5>
                    <p class="text-muted small">
                        A regra "{{ ruleToDelete?.title }}" será removida da base de conhecimento da IA.
                    </p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-danger px-4 rounded-3" @click="executeRuleDeletion"
                        :disabled="isDeletingRule">
                        <span v-if="isDeletingRule" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal de Criação de Nova Regra -->
    <div class="modal fade" id="createRuleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 p-2">
                <div class="modal-header border-0">
                    <h5 class="fw-bold m-0"><i class="bi bi-plus-circle text-primary me-2"></i>Nova Regra Manual</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Título da Regra</label>
                        <input type="text" v-model="newRule.title" class="form-control form-control-pmg"
                            placeholder="Ex: Horário de Funcionamento">
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Vincular aos Grupos (Opcional)</label>

                        <!-- Área de Exibição das Tags Selecionadas -->
                        <div v-if="newRule.group_ids && newRule.group_ids.length > 0"
                            class="d-flex flex-wrap gap-2 mb-2 p-2 border rounded-3 bg-light border-light">
                            <span v-for="id in newRule.group_ids" :key="id"
                                class="badge bg-pmg-primary d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                                {{ getGroupName(id) }}
                                <button type="button" class="btn-close btn-close-white" style="font-size: 0.5rem;"
                                    @click="removeGroupFromRule(id, 'newRule')"></button>
                            </span>
                        </div>

                        <!-- Select Simples para Adicionar -->
                        <select class="form-select form-control-pmg shadow-none"
                            @change="addGroupToRule($event, 'newRule')">
                            <option value="" selected>Selecione um grupo para vincular...</option>
                            <option v-for="group in unselectedGroups(newRule.group_ids)" :key="group.id"
                                :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                        <div class="form-text" style="font-size: 0.75rem;">Se vazio, a regra será Global.</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label small fw-bold text-muted">Instrução para a IA</label>
                        <textarea v-model="newRule.content" class="form-control form-control-pmg" rows="5"
                            placeholder="Digite a instrução para o bot..."></textarea>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button class="btn btn-pmg-light" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-pmg-primary" @click="submitManualRule"
                        :disabled="isSavingRule || !newRule.title || !newRule.content">
                        <span v-if="isSavingRule" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        Salvar Regra
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal de Gerenciar Grupos -->
    <div class="modal fade" id="manageGroupsModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 p-2">
                <div class="modal-header border-0">
                    <h5 class="fw-bold m-0"><i class="bi bi-tags-fill text-primary me-2"></i>Grupos</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitGroup" class="d-flex gap-2 mb-4">
                        <input type="text" v-model="newGroup.name" class="form-control form-control-pmg"
                            placeholder="Ex: Financeiro, Vendas..." required>
                        <button type="submit" class="btn btn-pmg-primary text-nowrap" :disabled="isSavingGroup">
                            <span v-if="isSavingGroup" class="spinner-border spinner-border-sm" role="status"></span>
                            <i v-else class="bi bi-plus-lg"></i> Adicionar
                        </button>
                    </form>

                    <h6 class="fw-bold text-muted small text-uppercase mb-3">Grupos Cadastrados</h6>
                    <div class="list-group rounded-3 shadow-sm">
                        <div v-if="groups.length === 0" class="list-group-item text-center text-muted py-4 small">
                            Nenhum grupo cadastrado. Regras atuarão de forma Global.
                        </div>
                        <div v-for="group in groups" :key="group.id"
                            class="list-group-item d-flex justify-content-between align-items-center border-light py-3">

                            <div class="d-flex align-items-center gap-2">
                                <span class="fw-medium text-dark">{{ group.name }}</span>
                                <!-- Badge visual indicando se é o padrão -->
                                <span v-if="group.id === defaultGroupId"
                                    class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle rounded-pill small">
                                    Padrão
                                </span>
                            </div>

                            <div class="d-flex align-items-center gap-1">
                                <!-- Botão para definir como Padrão -->
                                <button class="btn btn-sm hover-bg-light rounded-circle"
                                    :class="group.id === defaultGroupId ? 'text-warning' : 'text-muted'"
                                    @click="setDefaultGroup(group)"
                                    :disabled="isSettingDefault || group.id === defaultGroupId"
                                    :title="group.id === defaultGroupId ? 'Este é o grupo padrão' : 'Definir como Grupo Padrão'">
                                    <i :class="group.id === defaultGroupId ? 'bi bi-star-fill' : 'bi bi-star'"></i>
                                </button>

                                <!-- Botão de Excluir -->
                                <button class="btn btn-sm text-danger hover-bg-light rounded-circle"
                                    @click="confirmDeleteGroup(group.id)" title="Excluir Grupo">
                                    <i class="bi bi-trash3-fill"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import QRCode from 'qrcode';
import * as XLSX from 'xlsx';
import { Chart, registerables } from 'chart.js';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;
Chart.register(...registerables);

export default {
    inject: ['globalLoading'],
    data() {
        return {
            activeTab: 'connection',
            status: 'LOADING',
            qrCode: null,
            loading: false,
            alerts: [],
            pollingInterval: null,

            // Dados de Teste
            isSendingTest: false,
            testMessage: {
                number: '',
                message: ''
            },

            contacts: [],
            massMessageTemplate: '',
            isSendingMass: false,
            duplicateErrors: [],
            scheduleDate: '',
            scheduleTime: '',
            campaignHistory: [],
            campaignToCancel: null,
            loadingHistory: false,
            selectedCampaignMessages: [],
            loadingRecipients: false,
            metrics: null,
            chartInstance: null,
            conversations: [],
            activeChatPhone: null,
            activeChatMessages: [],
            newChatMessage: '',
            loadingConversations: false,
            loadingChat: false,
            isSendingChat: false,
            chatEventSource: null,
            pendingQuestions: [],
            knowledgeBase: [],
            isSavingRule: false,
            resolveForm: { id: null, question: '', title: '', content: '' },
            isResolving: false,
            isUpdatingRule: false,
            ruleToDelete: null,
            isDeletingRule: false,
            isTogglingAi: false,
            groups: [],
            newGroup: { name: '' },
            isSavingGroup: false,
            newRule: { title: '', content: '', group_ids: [] },
            ruleToEdit: { id: null, title: '', content: '', group_ids: [] },
            defaultGroupId: null,
            searchRuleQuery: '',
            selectedGroupFilter: '',
        }
    },
    computed: {
        activeConversation() {
            return this.conversations.find(c => c.phone === this.activeChatPhone);
        },
        activeChatName() {
            const conv = this.conversations.find(c => c.phone === this.activeChatPhone);
            return conv && conv.name !== 'Desconhecido' ? conv.name : null;
        },
        todayDate() {
            const dt = new Date();
            return dt.toISOString().split('T')[0];
        },
        scheduleError() {
            if (!this.scheduleDate && !this.scheduleTime) return null;
            if (this.scheduleDate && !this.scheduleTime) return "Defina um horário para o agendamento.";
            if (!this.scheduleDate && this.scheduleTime) return "Defina uma data para o agendamento.";

            const scheduledDateTime = new Date(`${this.scheduleDate}T${this.scheduleTime}`);
            const now = new Date();

            if (scheduledDateTime <= now) {
                return "O agendamento deve ser um momento no futuro.";
            }
            return null;
        },
        isValidToSubmit() {
            return this.contacts.length > 0 &&
                this.massMessageTemplate.trim().length > 0 &&
                this.duplicateErrors.length === 0 &&
                this.scheduleError === null;
        },
        filteredKnowledgeBase() {
            let filtered = this.knowledgeBase;

            // 1. Filtro por texto (título ou conteúdo da regra)
            if (this.searchRuleQuery.trim()) {
                const query = this.searchRuleQuery.toLowerCase();
                filtered = filtered.filter(rule =>
                    rule.title.toLowerCase().includes(query) ||
                    (rule.content && rule.content.toLowerCase().includes(query))
                );
            }

            // 2. Filtro por grupo selecionado
            if (this.selectedGroupFilter) {
                if (this.selectedGroupFilter === 'global') {
                    // Traz apenas regras que NÃO possuem grupos
                    filtered = filtered.filter(rule => !rule.groups || rule.groups.length === 0);
                } else {
                    // Traz regras que possuem o ID do grupo selecionado
                    filtered = filtered.filter(rule =>
                        rule.groups && rule.groups.some(g => g.id === this.selectedGroupFilter)
                    );
                }
            }

            return filtered;
        }
    },
    watch: {
        activeTab(newTab) {
            if (newTab === 'history') this.fetchHistory();
            else if (newTab === 'metrics') this.fetchMetrics();
            else if (newTab === 'chat') {
                this.fetchConversations();
                this.startGlobalStream(); // Inicia o radar global!
            } else if (newTab === 'bot_training') {
                this.fetchPendingQuestions();
                this.fetchKnowledgeBase();
                this.fetchGroups();
            }
        }
    },
    mounted() {
        this.fetchStatus();
    },

    beforeUnmount() {
        this.stopPolling();
        if (this.chatEventSource) {
            this.chatEventSource.close();
        }
    },
    methods: {
        async fetchMetrics() {
            try {
                const response = await api.get('/whatsapp/metrics');
                this.metrics = response.data;

                // Precisamos de um $nextTick para garantir que o <canvas> foi renderizado antes de montar o gráfico
                this.$nextTick(() => {
                    this.renderChart();
                });
            } catch (error) {
                console.error("Erro ao buscar métricas:", error);
                this.showAlert('Erro ao carregar o dashboard.', 'error');
            }
        },

        renderChart() {
            const ctx = this.$refs.metricsChartCanvas;
            if (!ctx) return;

            // Se já existe um gráfico, destruímos antes de criar um novo para não sobrepor
            if (this.chartInstance) {
                this.chartInstance.destroy();
            }

            this.chartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: this.metrics.chart.labels,
                    datasets: [
                        {
                            label: 'Enviadas',
                            data: this.metrics.chart.sent,
                            borderColor: '#0d6efd', // Azul Bootstrap
                            backgroundColor: 'rgba(13, 110, 253, 0.1)',
                            borderWidth: 2,
                            tension: 0.4, // Deixa a linha suave/curvada
                            fill: true
                        },
                        {
                            label: 'Recebidas',
                            data: this.metrics.chart.received,
                            borderColor: '#198754', // Verde Bootstrap
                            backgroundColor: 'rgba(25, 135, 84, 0.1)',
                            borderWidth: 2,
                            tension: 0.4,
                            fill: true
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { position: 'top' },
                        tooltip: { mode: 'index', intersect: false }
                    },
                    scales: {
                        y: { beginAtZero: true },
                        x: { grid: { display: false } }
                    }
                }
            });
        },
        async fetchHistory() {
            this.loadingHistory = true;
            this.globalLoading.show('Carregando campanhas...');
            try {
                // Rota a ser criada no Laravel para listar o histórico
                const response = await api.get('/whatsapp/campaigns');
                this.campaignHistory = response.data;
            } catch (error) {
                console.error("Erro ao buscar histórico:", error);
            } finally {
                this.loadingHistory = false;
                this.globalLoading.hide();
            }
        },
        async fetchStatus() {
            try {
                const response = await api.get('/whatsapp/status');
                const data = response.data;

                this.status = data.status || 'DISCONNECTED';

                if (data.qr) {
                    this.qrCode = await QRCode.toDataURL(data.qr);
                }

                if (this.status === 'WAITING_QR') {
                    this.startPolling();
                } else if (this.status === 'CONNECTED') {
                    this.stopPolling();
                }

            } catch (error) {
                this.status = 'DISCONNECTED';
                console.error("Erro ao buscar status do WhatsApp:", error);
            }
        },

        async connectWhatsApp() {
            this.loading = true;
            try {
                const response = await api.post('/whatsapp/connect');

                if (response.data.status) {
                    this.status = response.data.status;
                }
                if (response.data.qr) {
                    this.qrCode = await QRCode.toDataURL(response.data.qr);
                }

                this.showAlert('Instância iniciada. Aguardando QR Code.', 'success');
                this.startPolling();

            } catch (error) {
                this.showAlert('Falha ao tentar conectar.', 'error');
            } finally {
                this.loading = false;
            }
        },

        startPolling() {
            if (this.pollingInterval) return;
            this.pollingInterval = setInterval(async () => {
                await this.fetchStatus();
                if (this.status === 'CONNECTED') {
                    this.showAlert('WhatsApp conectado com sucesso!', 'success');
                }
            }, 3000);
        },

        stopPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },

        confirmDisconnect() {
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDisconnectModal'));
            modal.show();
        },

        async executeDisconnect() {
            try {
                await api.post('/whatsapp/disconnect');
                this.status = 'DISCONNECTED';
                this.qrCode = null;
                this.stopPolling();
                this.showAlert('Sessão encerrada com sucesso.', 'success');
            } catch (error) {
                this.showAlert('Erro ao desconectar.', 'error');
            } finally {
                const modalElement = document.getElementById('confirmDisconnectModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
            }
        },

        async sendTestMessage() {
            this.isSendingTest = true;
            try {
                let cleanNumber = this.testMessage.number.replace(/\D/g, '');
                if (cleanNumber.length === 10 || cleanNumber.length === 11) {
                    cleanNumber = '55' + cleanNumber;
                }

                const payload = {
                    type: 'teste',
                    messages: [
                        {
                            number: cleanNumber,
                            message: this.testMessage.message
                        }
                    ]
                };

                await api.post('/whatsapp/send-message', payload);
                this.showAlert('Mensagem enviada para a fila de disparo!', 'success');
                this.testMessage.message = '';

            } catch (error) {
                if (error.response?.status === 422) {
                    this.showAlert('Verifique os dados do número de destino.', 'error');
                } else {
                    this.showAlert('Erro ao enviar mensagem.', 'error');
                }
            } finally {
                this.isSendingTest = false;
            }
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) {
                this.contacts = [];
                this.duplicateErrors = [];
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    const json = XLSX.utils.sheet_to_json(worksheet);
                    this.duplicateErrors = [];
                    this.contacts = [];

                    const seenNumbers = new Map();

                    json.forEach((row, index) => {
                        if (!row.Telefone) return;

                        const excelRow = index + 2;
                        let cleanNumber = String(row.Telefone).replace(/\D/g, '');
                        if (cleanNumber.length === 10 || cleanNumber.length === 11) {
                            cleanNumber = '55' + cleanNumber;
                        }

                        // Verifica se o número limpo já passou por aqui
                        if (seenNumbers.has(cleanNumber)) {
                            const linhaOriginal = seenNumbers.get(cleanNumber);
                            this.duplicateErrors.push(`Linha ${excelRow}: O número ${row.Telefone} já existe na ${linhaOriginal}.`);
                        } else {
                            seenNumbers.set(cleanNumber, `Linha ${excelRow}`);
                            this.contacts.push(row);
                        }
                    });

                    if (this.duplicateErrors.length > 0) {
                        this.showAlert('Correção necessária! Verifique os números duplicados listados.', 'error');
                    } else if (this.contacts.length === 0) {
                        this.showAlert('Nenhuma coluna "Telefone" encontrada na planilha.', 'warning');
                        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
                    }

                } catch (error) {
                    this.showAlert('Falha ao ler o arquivo Excel. Verifique o formato.', 'error');
                    console.error(error);
                }
            };

            reader.readAsArrayBuffer(file);
        },

        async sendMassMessages() {
            this.isSendingMass = true;

            try {
                const payload = this.contacts.map(contact => {
                    let cleanNumber = String(contact.Telefone).replace(/\D/g, '');
                    if (cleanNumber.length === 10 || cleanNumber.length === 11) {
                        cleanNumber = '55' + cleanNumber;
                    }
                    return { number: cleanNumber, message: this.massMessageTemplate };
                });

                let scheduledAt = null;
                if (this.scheduleDate && this.scheduleTime) {
                    scheduledAt = `${this.scheduleDate} ${this.scheduleTime}:00`;
                }

                await api.post('/whatsapp/campaign', {
                    scheduled_at: scheduledAt,
                    messages: payload
                });

                this.showAlert('Campanha registrada com sucesso!', 'success');
            } catch (error) {
                console.error("Erro no envio em massa:", error);
                this.showAlert('Falha ao processar campanha.', 'error');
            } finally {
                this.isSendingMass = false;
            }
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamation-triangle-fill'; // Corrigido a classe do ícone
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },
        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        applyPhoneMask() {
            let value = this.testMessage.number.replace(/\D/g, '');
            if (value.length > 11) value = value.slice(0, 11);

            if (value.length > 2) value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
            if (value.length > 7) value = value.replace(/(\d{4,5})(\d{4})$/, '$1-$2');

            this.testMessage.number = value;
        },
        downloadExample() {
            const data = [
                {
                    Nome: 'João Silva',
                    Telefone: '5511999999999'
                },
                {
                    Nome: 'Maria Oliveira',
                    Telefone: '88988888888'
                }
            ];

            const worksheet = XLSX.utils.json_to_sheet(data);

            worksheet['!cols'] = [
                { wch: 45 }, // Largura da coluna Nome
                { wch: 20 }  // Largura da coluna Telefone
            ];

            // 3. Criamos o arquivo (workbook) e inserimos a aba
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Contatos');

            XLSX.writeFile(workbook, 'Modelo_Importacao_RMR.xlsx');
        },

        clearList() {
            this.contacts = [];
            this.duplicateErrors = []; // <== Limpa os erros também

            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }

            this.showAlert('Lista descartada. Você pode importar um novo arquivo.', 'warning');
        },

        formatDateTime(datetime) {
            if (!datetime) return '-';
            const dt = new Date(datetime);
            return dt.toLocaleString('pt-BR');
        },

        confirmCancelCampaign(campaign) {
            this.campaignToCancel = campaign;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmCancelCampaignModal'));
            modal.show();
        },
        async executeCancel() {
            if (!this.campaignToCancel) return;

            try {
                await api.delete(`/whatsapp/campaign/${this.campaignToCancel.id}`);

                this.showAlert('Campanha cancelada com sucesso.', 'success');

                await this.fetchHistory();

            } catch (error) {
                this.showAlert('Erro ao cancelar campanha.', 'error');
                console.error(error);
            } finally {
                const modalElement = document.getElementById('confirmCancelCampaignModal');
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                    modalInstance.hide();
                }
                this.campaignToCancel = null;
            }
        },

        async openRecipientsModal(campanha) {
            this.selectedCampaignMessages = [];
            const modal = new window.bootstrap.Modal(document.getElementById('campaignRecipientsModal'));
            modal.show();

            this.loadingRecipients = true;

            try {
                const response = await api.get(`/whatsapp/campaign/${campanha.id}/messages`);
                this.selectedCampaignMessages = response.data;
            } catch (error) {
                console.error("Erro ao buscar destinatários:", error);
                this.showAlert('Erro ao carregar a lista de destinatários.', 'error');
            } finally {
                this.loadingRecipients = false;
            }
        },

        formatPhone(phone) {
            if (!phone) return '';
            const str = String(phone);
            if (str.length === 13 && str.startsWith('55')) {
                return `+${str.substring(0, 2)} (${str.substring(2, 4)}) ${str.substring(4, 9)}-${str.substring(9)}`;
            }
            return str;
        },

        async fetchConversations() {
            this.loadingConversations = true;
            try {
                const response = await api.get('/whatsapp/chat/conversations');
                this.conversations = response.data;
            } catch (error) {
                console.error("Erro", error);
            } finally {
                this.loadingConversations = false;
            }
        },

        async openChat(phone) {
            this.activeChatPhone = phone;
            this.loadingChat = true;
            try {
                const response = await api.get(`/whatsapp/chat/${phone}`);
                this.activeChatMessages = response.data;
                this.scrollToBottom();
            } catch (error) {
                console.error("Erro ao carregar chat", error);
            } finally {
                this.loadingChat = false;
            }
            // OBSERVAÇÃO: Removemos a chamada do stream daqui, pois ele agora é global.
        },

        startGlobalStream() {
            // 1. Pega o token JWT que você já usa nas requisições normais
            const token = localStorage.getItem('access_token'); // Ajuste se o nome da sua chave no localStorage for outro

            // Ajuste para a URL da sua API
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000/api';

            if (!token) {
                console.error("Token não encontrado. WebSocket não iniciado.");
                return;
            }

            // 2. Se já existir uma conexão aberta, fechamos para não duplicar
            if (window.Echo) {
                window.Echo.leave('whatsapp');
            }

            // 3. Configura a conexão com o Reverb e envia o JWT para autorização
            window.Echo = new Echo({
                broadcaster: 'reverb',
                key: process.env.VUE_APP_REVERB_APP_KEY || '***',
                wsHost: process.env.VUE_APP_REVERB_HOST || 'localhost', // Fallback seguro
                wsPort: process.env.VUE_APP_REVERB_PORT || 6001,
                wssPort: process.env.VUE_APP_REVERB_PORT || 6001,

                // A MÁGICA ESTÁ AQUI: Só força TLS se a variável disser explicitamente 'https'
                forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',

                encrypted: false, // O Echo mais recente ignora isso a favor do forceTLS, mas não faz mal deixar
                disableStats: true,
                enabledTransports: ['ws', 'wss'],
                authEndpoint: `${baseUrl}/broadcasting/auth`,
                auth: {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: 'application/json'
                    }
                }
            });

            // 4. Conecta no canal privado e escuta o evento
            window.Echo.private('whatsapp')
                // Atenção ao PONTO antes do nome: ele indica que usamos o método broadcastAs() no back-end
                .listen('.message.received', (e) => {
                    this.processWhatsAppUpdates([e.message]);
                })
                .error((error) => {
                    console.error("Erro na conexão WebSocket:", error);
                });
        },
        // Separei a lógica visual em outro método para deixar o código limpo
        processWhatsAppUpdates(updates) {
            if (!updates || updates.length === 0) return;

            updates.forEach(updatedMsg => {
                // O telefone e o nome agora vêm do relacionamento carregado no back-end
                const msgPhone = updatedMsg.contact ? updatedMsg.contact.phone : null;
                if (!msgPhone) return;

                const isCurrentChat = String(this.activeChatPhone) === String(msgPhone);

                if (isCurrentChat) {
                    const index = this.activeChatMessages.findIndex(m => m.id === updatedMsg.id);

                    if (index !== -1) {
                        this.activeChatMessages[index] = updatedMsg;
                    } else {
                        this.activeChatMessages.push(updatedMsg);
                        this.scrollToBottom();
                    }
                }

                // Atualiza a Sidebar
                const convIndex = this.conversations.findIndex(c => String(c.phone) === String(msgPhone));
                if (convIndex !== -1) {
                    // Atualiza a data e injeta a nova mensagem como a mais recente
                    this.conversations[convIndex].last_activity = updatedMsg.created_at;

                    if (!this.conversations[convIndex].messages) {
                        this.conversations[convIndex].messages = [];
                    }
                    this.conversations[convIndex].messages[0] = updatedMsg;

                    // Reordena a lista para subir a conversa
                    this.conversations.sort((a, b) => new Date(b.last_activity) - new Date(a.last_activity));
                } else {
                    // Contato 100% novo, busca a lista da API para criar a caixa na sidebar
                    this.fetchConversations();
                }
            });
        },

        async sendChatMessage() {
            if (!this.newChatMessage.trim()) return;

            this.isSendingChat = true;
            const messageText = this.newChatMessage;
            this.newChatMessage = ''; // Limpa o input rápido para UX

            try {
                // Usa a sua rota existente de envio simples!
                await api.post('/whatsapp/send-message', {
                    type: 'chat',
                    messages: [
                        { number: this.activeChatPhone, message: messageText }
                    ]
                });

                // Recarrega o chat para ver a nova mensagem
                await this.openChat(this.activeChatPhone);
                // Atualiza a lista da esquerda para a conversa subir
                this.fetchConversations();
            } catch (error) {
                this.showAlert('Erro ao enviar mensagem', 'error');
            } finally {
                this.isSendingChat = false;
            }
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.chatScrollArea;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },

        formatTimeOnly(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        },
        // --- MÉTODOS DO TREINAMENTO DE IA ---

        async fetchPendingQuestions() {
            try {
                const response = await api.get('/bot/pending-questions');
                this.pendingQuestions = response.data.data; // O Laravel envelopa em 'data'
            } catch (error) {
                this.showAlert('Erro ao buscar dúvidas pendentes.', 'error');
            }
        },

        async fetchKnowledgeBase() {
            try {
                const response = await api.get('/bot/knowledge');
                this.knowledgeBase = response.data.data;
            } catch (error) {
                this.showAlert('Erro ao carregar a base de conhecimento.', 'error');
            }
        },

        openResolveModal(question) {
            this.resolveForm = {
                id: question.id,
                question: question.question,
                title: '',
                content: ''
            };
            const modal = new window.bootstrap.Modal(document.getElementById('resolveQuestionModal'));
            modal.show();
        },

        async submitResolve() {
            this.isResolving = true;
            try {
                await api.post(`/bot/pending-questions/${this.resolveForm.id}/resolve`, {
                    title: this.resolveForm.title,
                    content: this.resolveForm.content
                });

                this.showAlert('Bot treinado com sucesso!', 'success');

                // Atualiza as listas
                await this.fetchPendingQuestions();
                await this.fetchKnowledgeBase();

                // Fecha o modal
                const modalElement = document.getElementById('resolveQuestionModal');
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) modalInstance.hide();

            } catch (error) {
                this.showAlert('Erro ao resolver a dúvida.', 'error');
            } finally {
                this.isResolving = false;
            }
        },

        async submitManualRule() {
            this.isSavingRule = true;
            try {
                // Agora envia o array de IDs junto com a regra
                await api.post('/bot/knowledge', {
                    title: this.newRule.title,
                    content: this.newRule.content,
                    // A chave foi ajustada para group_ids para bater com o back-end
                    group_ids: this.newRule.group_ids
                });

                this.showAlert('Regra adicionada ao cérebro da IA!', 'success');
                this.newRule = { title: '', content: '', group_ids: [] };
                await this.fetchKnowledgeBase();

                const modalElement = document.getElementById('createRuleModal');
                if (modalElement) window.bootstrap.Modal.getInstance(modalElement)?.hide();
            } catch (error) {
                this.showAlert('Erro ao salvar a regra manual.', 'error');
            } finally {
                this.isSavingRule = false;
            }
        },
        confirmDeleteQuestion(question) {
            this.questionToDelete = question;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteQuestionModal'));
            modal.show();
        },

        async executeQuestionDeletion() {
            if (!this.questionToDelete) return;

            this.isDeletingQuestion = true;

            try {
                await api.delete(`/bot/pending-questions/${this.questionToDelete.id}`);

                this.showAlert('Dúvida descartada com sucesso!', 'warning');

                // Remove da lista local
                this.pendingQuestions = this.pendingQuestions.filter(q => q.id !== this.questionToDelete.id);

                // Fecha o modal
                const modalElement = document.getElementById('confirmDeleteQuestionModal');
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                    modalInstance.hide();
                }
            } catch (error) {
                console.error('Erro ao excluir dúvida pendente:', error);
                this.showAlert('Erro ao descartar a dúvida.', 'error');
            } finally {
                this.isDeletingQuestion = false;
                this.questionToDelete = null;
            }
        },
        // --- MÉTODOS DE EDIÇÃO E EXCLUSÃO DE REGRAS ---

        openEditRuleModal(rule) {
            // Mapeia os IDs dos grupos atuais da regra para o select múltiplo
            const currentGroupIds = rule.groups ? rule.groups.map(g => g.id) : [];

            this.ruleToEdit = {
                ...rule,
                group_ids: currentGroupIds
            };
            const modal = new window.bootstrap.Modal(document.getElementById('editRuleModal'));
            modal.show();
        },

        async submitEditRule() {
            this.isUpdatingRule = true;
            try {
                await api.put(`/bot/knowledge/${this.ruleToEdit.id}`, {
                    title: this.ruleToEdit.title,
                    content: this.ruleToEdit.content,
                    group_ids: this.ruleToEdit.group_ids // Envia os novos IDs
                });

                this.showAlert('Regra atualizada com sucesso!', 'success');
                await this.fetchKnowledgeBase();

                const modalElement = document.getElementById('editRuleModal');
                if (modalElement) window.bootstrap.Modal.getInstance(modalElement)?.hide();
            } catch (error) {
                this.showAlert('Erro ao atualizar a regra.', 'error');
            } finally {
                this.isUpdatingRule = false;
            }
        },

        confirmDeleteRule(rule) {
            this.ruleToDelete = rule;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteRuleModal'));
            modal.show();
        },

        async executeRuleDeletion() {
            if (!this.ruleToDelete) return;

            this.isDeletingRule = true;
            try {
                await api.delete(`/bot/knowledge/${this.ruleToDelete.id}`);

                this.showAlert('Regra removida da base de conhecimento.', 'warning');
                await this.fetchKnowledgeBase();

                const modalElement = document.getElementById('confirmDeleteRuleModal');
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) modalInstance.hide();
            } catch (error) {
                console.error('Erro ao excluir regra:', error);
                this.showAlert('Erro ao excluir a regra.', 'error');
            } finally {
                this.isDeletingRule = false;
                this.ruleToDelete = null;
            }
        },
        openCreateRuleModal() {
            this.newRule = { title: '', content: '', group_ids: [] };
            const modal = new window.bootstrap.Modal(document.getElementById('createRuleModal'));
            modal.show();
        },

        async toggleAiStatus(event) {
            if (!this.activeConversation) return;

            const newState = event.target.checked;
            this.isTogglingAi = true;

            try {
                await api.post(`/whatsapp/chat/${this.activeChatPhone}/toggle-ai`, {
                    bot_enabled: newState // <-- Alterado aqui
                });

                this.activeConversation.bot_enabled = newState; // <-- Alterado aqui

                const statusText = newState ? 'ativada' : 'pausada';
                this.showAlert(`IA ${statusText} para este contato.`, newState ? 'success' : 'warning');

            } catch (error) {
                console.error("Erro ao alterar status da IA:", error);
                this.showAlert('Erro ao atualizar o status da IA.', 'error');
                event.target.checked = !newState;
            } finally {
                this.isTogglingAi = false;
            }
        },
        async fetchGroups() {
            try {
                const response = await api.get('/knowledge-base-groups');
                this.groups = response.data.data;
                this.defaultGroupId = response.data.default_group;
            } catch (error) {
                console.error('Erro ao buscar grupos', error);
            }
        },
        openManageGroupsModal() {
            const modal = new window.bootstrap.Modal(document.getElementById('manageGroupsModal'));
            modal.show();
        },
        async submitGroup() {
            if (!this.newGroup.name) return;
            this.isSavingGroup = true;
            try {
                const response = await api.post('/knowledge-base-groups', { name: this.newGroup.name });
                this.groups.push(response.data.data);
                this.newGroup.name = '';
                this.showAlert('Grupo criado com sucesso.', 'success');
            } catch (error) {
                this.showAlert('Erro ao criar grupo.', 'error');
            } finally {
                this.isSavingGroup = false;
            }
        },
        async confirmDeleteGroup(id) {
            if (!confirm('Deseja realmente excluir este grupo?')) return;
            try {
                await api.delete(`/knowledge-base-groups/${id}`);
                this.groups = this.groups.filter(g => g.id !== id);
                this.showAlert('Grupo removido.', 'warning');
                this.fetchKnowledgeBase(); // Atualiza a base para refletir remoção
            } catch (error) {
                this.showAlert('Erro ao remover o grupo.', 'error');
            }
        },
        getGroupName(id) {
            const group = this.groups.find(g => g.id === id);
            return group ? group.name : 'Desconhecido';
        },

        // 2. Filtra o dropdown para mostrar apenas grupos que AINDA NÃO foram selecionados
        unselectedGroups(selectedIds) {
            if (!selectedIds) return this.groups;
            return this.groups.filter(g => !selectedIds.includes(g.id));
        },

        // 3. Adiciona o grupo ao array e reseta o select
        addGroupToRule(event, targetRule) {
            const selectedId = event.target.value;
            if (!selectedId) return;

            if (targetRule === 'newRule') {
                if (!this.newRule.group_ids.includes(selectedId)) {
                    this.newRule.group_ids.push(selectedId);
                }
            } else if (targetRule === 'ruleToEdit') {
                if (!this.ruleToEdit.group_ids.includes(selectedId)) {
                    this.ruleToEdit.group_ids.push(selectedId);
                }
            }

            // Devolve o select para a opção padrão ("Selecione um grupo...")
            event.target.value = "";
        },

        // 4. Remove a tag quando o usuário clica no "X"
        removeGroupFromRule(id, targetRule) {
            if (targetRule === 'newRule') {
                this.newRule.group_ids = this.newRule.group_ids.filter(gId => gId !== id);
            } else if (targetRule === 'ruleToEdit') {
                this.ruleToEdit.group_ids = this.ruleToEdit.group_ids.filter(gId => gId !== id);
            }
        },

        async setDefaultGroup(group) {
            if (this.defaultGroupId === group.id) return;

            this.isSettingDefault = true;
            try {
                await api.post('/bot/knowledge/default-group', {
                    group_ia: group.id // Envia o UUID do grupo
                });

                this.defaultGroupId = group.id; // Atualiza localmente na hora para UI responder rápido
                this.showAlert(`O grupo "${group.name}" agora é o padrão da IA!`, 'success');
            } catch (error) {
                console.error('Erro ao definir grupo padrão:', error);
                this.showAlert('Erro ao definir o grupo padrão.', 'error');
                await this.fetchGroups(); // Reverte caso dê erro
            } finally {
                this.isSettingDefault = false;
            }
        }


    }
}
</script>

<style scoped>
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

.bg-warning-subtle {
    background-color: #fffbeb !important;
    color: #92400e !important;
    border-left: 5px solid #f59e0b !important;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
    animation: shake 0.4s ease-in-out;
}

/* --- ESTILOS DAS ABAS --- */
.cursor-pointer {
    cursor: pointer;
}

.transition-all {
    transition: all 0.3s ease;
}

.bg-pmg-primary {
    background-color: #561569 !important;
}

.hover-bg-light:hover {
    background-color: #f8fafc;
}

.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

/* --- SCROLLBAR CUSTOMIZADA PARA O ALERTA DE ERRO --- */
.custom-scrollbar-danger::-webkit-scrollbar {
    width: 6px;
}

.custom-scrollbar-danger::-webkit-scrollbar-track {
    background: rgba(220, 38, 38, 0.1);
    /* Fundo vermelho bem clarinho */
    border-radius: 10px;
}

.custom-scrollbar-danger::-webkit-scrollbar-thumb {
    background: rgba(220, 38, 38, 0.4);
    /* Vermelho médio para a barrinha */
    border-radius: 10px;
}

.custom-scrollbar-danger::-webkit-scrollbar-thumb:hover {
    background: rgba(220, 38, 38, 0.6);
    /* Fica mais escuro ao passar o mouse */
}

/* Tabela Padrão PMG */
.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.pmg-desc-cell {
    color: #64748b;
    font-size: 0.9rem;
}

.cursor-pointer {
    cursor: pointer;
}

.transition-all {
    transition: all 0.2s ease-in-out;
}

.hover-bg-light:hover {
    background-color: #f8fafc !important;
}

.chat-window {
    background-color: #f0f2f5;
    display: flex;
    flex-direction: column;
}

/* Área de mensagens */
.chat-messages {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=');
    background-color: #e5ddd5;
    /* Cor clássica de chat */
    padding: 20px;
    flex-grow: 1;
    overflow-y: auto;
}

/* Bolhas de mensagem */
.bubble {
    padding: 8px 14px;
    border-radius: 12px;
    position: relative;
    max-width: 75%;
    font-size: 0.95rem;
    line-height: 1.4;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.bubble.received {
    background: #ffffff;
    border-top-left-radius: 0;
}

.bubble.sent {
    background: #dcf8c6;
    /* Verde suave de chat */
    border-top-right-radius: 0;
}

/* Input moderno */
.chat-input-area {
    background: #f0f0f0;
    padding: 10px 15px;
}

/* Sidebar Conversations */
.conv-item {
    transition: all 0.2s ease;
    border-left: 4px solid transparent;
}

.conv-item:hover {
    background: #f8f9fa;
}

.conv-item.active {
    background: #e7f3ff !important;
    border-left-color: #0d6efd;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}
</style>